import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Home from "./Components/Home/Home";
import About from "./Components/About/About";
import Contact from "./Components/Contact/Contact";
import Service from "./Components/Service/Service";
import Career from "./Components/Career/Career";
import Repay from "./Components/Repay/Repay";
import PartnerDirectory from "./Components/PartnerDirectory/PartnerDirectory";
import Policies from "./Components/Policies/Policies";
import DLA from "./Components/DLA/DLA";
import GrievanceRedressal from "./Components/GrievanceRedressal/GrievanceRedressal";

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/service" element={<Service />} />
        <Route path="/career" element={<Career />} />
        <Route path="/partner-directory" element={<PartnerDirectory />} />
        <Route path="/repay" element={<Repay />} />
        <Route path="/policies" element={<Policies />} />
        <Route path="/dla" element={<DLA />} />
        <Route path="/grievance-redressal" element={<GrievanceRedressal />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
